export default {"src":"/_next/static/media/plus.ceed00b0.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};